import Vue from 'vue'
import Router from 'vue-router'

import Head from '@/page/layout/head.vue'
import Left from '@/page/layout/left_side.vue'
import Login from '@/page/login/index'
import Logan from 'logan-web';
import Cookies from 'js-cookie'

/*181026 by:jw*/
//首页
const index = () => import('@/page/index/index')
// 基础数据
const category_manage = () => import('@/page/base_data/category_manage') //类目模板
const size_manage = () => import('@/page/base_data/size_manage') //规格属性管理
const trade_manage = () => import('@/page/base_data/trade_manage') //行业管理
const member_attribute = () => import('@/page/base_data/member_attribute') //会员属性
const member_template = () => import('@/page/base_data/member_template') //会员模版
// （新）基础数据
const new_category_manage = () => import('@/page/new_base_data/new_category_manage') //类目模板
const new_size_manage = () => import('@/page/new_base_data/new_size_manage') //规格属性管理
//商户管理
const merchant_manage = () => import('@/page/shop_manage/merchant_manage') //商家管理
const store_manage = () => import('@/page/shop_manage/store_manage') //门店管理
// 新商户管理
const new_merchant_manage = () => import('@/page/new_shop_manage/merchant_manage') //商家管理
const new_store_manage = () => import('@/page/new_shop_manage/store_manage') //门店管理
const agentUser = () => import('@/page/shop_manage/agentUser') //代理推广用户
const agentManage = () => import('@/page/shop_manage/agentManage') //代理商管理
const user = () => import('@/page/shop_manage/user') //用户
//体验账号统计
const experience_info = () => import('@/page/experience_info/experience_info')
// 系统管理
const version_manage = () => import('@/page/system_manage/version_manage') //版本管理
const copywriting = () => import('@/page/system_manage/copywriting') //文案设置
const login_log = () => import('@/page/system_manage/login_log') //登录日志
const notice = () => import('@/page/system_manage/notice') //公告通知
const help_center = () => import('@/page/system_manage/help_center') //帮助中心
const test_manage = () => import('@/page/system_manage/test_manage') //验证管理
const role_manage = () => import('@/page/system_manage/role_manage') //角色管理
const accountManage = () => import('@/page/system_manage/accountManage') //账号管理
const menu_auth_manage = () => import('@/page/system_manage/menu_auth_manage') //菜单权限

// 营销管理
const product = () => import('@/page/marketingManage/product') //产品定价
const loginAward = () => import('@/page/marketingManage/loginAward') //登录注册奖励
const bannerManage = () => import('@/page/marketingManage/bannerManage') //banner管理
const bannerEdit = () => import('@/page/marketingManage/bannerEdit') //banner编辑
const thematicActivitiesManage = () => import('@/page/marketingManage/thematicActivitiesManage') //主题活动管理
const MicroShoppingMall = () => import('@/page/marketingManage/MicroShoppingMall');
const serviceOrder = () => import('@/page/marketingManage/serviceOrder'); // 在线支付订单
//redis
const redis = () => import('@/page/shop_manage/redis') //redis

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/index',
      component: Head,
      children: [
        {
          path: '/index',
          component: Left,
          children: [{path: '/index', name: 'index', component: index}]
        },
        {
          path: '/base_data',
          component: Left,
          children: [
            Object.assign({path: 'category_manage', component: category_manage, name: 'category_manage'},
              Cookies.get('upgraded') != '0' ? {redirect: () => {
                  return 'new_category_manage'}
              } : {}
            ),
            Object.assign({path: 'size_manage', component: size_manage, name: 'size_manage'},
              Cookies.get('upgraded') != '0' ? {redirect: () => {
                  return 'new_size_manage'}
              } : {}
            ),
            {path: 'new_category_manage', component: new_category_manage, name: 'new_category_manage'},
            {path: 'new_size_manage', component: new_size_manage, name: 'new_size_manage'},
            {path: 'trade_manage', component: trade_manage, name: 'trade_manage'},
            {path: 'member_attribute', component: member_attribute, name: 'member_attribute'},
            {path: 'member_template', component: member_template, name: 'member_template'}
          ]
        },
        {
          path: '/shop_manage',
          component: Left,
          children: [
            Object.assign({path: 'merchant_manage', component: merchant_manage, name: 'merchant_manage'},
              Cookies.get('upgraded') != '0' ? {redirect: () => {
                  return 'new_merchant_manage'}
              } : {}
            ),
            Object.assign({path: 'store_manage', component: store_manage, name: 'store_manage'},
              Cookies.get('upgraded') != '0' ? {redirect: () => {
                  return 'new_store_manage'}
              } : {}
            ),
            {path: 'new_merchant_manage', component: new_merchant_manage, name: 'merchant_manage'},
            {path: 'new_store_manage', component: new_store_manage, name: 'store_manage'},
            {path: 'agentUser', component: agentUser, name: 'agentUser'},
            {path: 'agentManage', component: agentManage, name: 'agentManage'},
            {path: 'user', component: user, name: 'user'},
            {path: '/redis', component: redis, name: 'redis'},
          ]
        },
        {
          path: '/marketingManage',
          component: Left,
          children: [
            {path: 'product', component: product, name: 'product'},
            {path: 'loginAward', component: loginAward, name: 'loginAward'},
            {path: 'bannerManage', component: bannerManage, name: 'bannerManage'},
            {path: 'bannerEdit', component: bannerEdit, name: 'bannerEdit'},
            {path: 'thematicActivitiesManage', component: thematicActivitiesManage, name: 'thematicActivitiesManage'},
            {path: 'experience_info', component: experience_info, name: 'experience_info'},
            {path: 'versionManage', component: () => import('@/page/marketingManage/versionManage'), name: 'versionManage'},
            {path: 'experienceConfig', component: () => import('@/page/marketingManage/experienceConfig'), name: 'experienceConfig'},
            {path: 'gradeConfig', component: () => import('@/page/marketingManage/gradeConfig'), name: 'gradeConfig'},
            {path: '/printRecord', component: () => import('@/page/marketingManage/printRecord'), name: 'printRecord'},
            {path: 'exchangeCode', component: () => import('@/page/marketingManage/exchangeCode'), name: 'exchangeCode'},
            {path: 'exchangeHistory', component: () => import('@/page/marketingManage/exchangeHistory'), name: 'exchangeHistory'},
            {path: 'micro-shoppingmall', component: MicroShoppingMall, name: 'MicroShoppingMall'},
            {path: 'service-order', component: serviceOrder, name: 'serviceOrder'}
          ]
        },
        {
          path: '/system_manage',
          component: Left,
          children: [
            {path: 'version_manage', component: version_manage, name: 'version_manage'},
            {path: 'copywriting', component: copywriting, name: 'copywriting'},
            {path: 'login_log', component: login_log, name: 'login_log'},
            {path: 'notice', component: notice, name: 'notice'},
            {path: 'help_center', component: help_center, name: 'help_center'},
            {path: 'test_manage', component: test_manage, name: 'test_manage'},
            {path: 'role_manage', component: role_manage, name: 'role_manage'},
            {path: 'accountManage', component: accountManage, name: 'accountManage'},
            {path: 'menu_auth_manage', component: menu_auth_manage, name: 'menuAuthManage'},
            {path: 'promotion_manage', component: () => import('@/page/system_manage/promotion_manage'), name: 'promotionManage'}
          ]
        },
      ]
    },
    {path: '*', component: () => import('@/page/404/404.vue')}
  ]
});
Logan.initConfig({
  reportUrl: 'https://yourServerAddressToAcceptLogs',
  publicKey: '-----BEGIN PUBLIC KEY-----\n'+
    'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgG2m5VVtZ4mHml3FB9foDRpDW7Pw\n'+
    'Foa+1eYN777rNmIdnmezQqHWIRVcnTRVjrgGt2ndP2cYT7MgmWpvr8IjgN0PZ6ng\n'+
    'MmKYGpapMqkxsnS/6Q8UZO4PQNlnsK2hSPoIDeJcHxDvo6Nelg+mRHEpD6K+1FIq\n'+
    'zvdwVPCcgK7UbZElAgMBAAE=\n'+
    '-----END PUBLIC KEY-----',
  errorHandler: function(e) {}
});
router.beforeEach((to, from, next) => {
  const content = `从${from.name}页面进入${to.name}页面`;
  Logan.logWithEncryption(content, 1);
  next()
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js